import { __rest } from "tslib";
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Choice } from '../Choice';
import { Input } from './styled';
import { generateId } from '../../utils/generateId';
export const Checkbox = (_a) => {
    var { checked, indeterminate, value, name, disabled, ariaLabel, className, onChange } = _a, otherProps = __rest(_a, ["checked", "indeterminate", "value", "name", "disabled", "ariaLabel", "className", "onChange"]);
    const id = useMemo(() => generateId('checkbox'), []);
    const checkboxRef = useRef(null);
    const handleChange = useCallback((e) => {
        onChange(e.currentTarget.checked, value);
    }, [onChange, value]);
    useEffect(() => {
        if (!checkboxRef.current)
            return;
        if (indeterminate === true) {
            checkboxRef.current.indeterminate = true;
            return;
        }
        checkboxRef.current.indeterminate = false;
    }, [indeterminate]);
    return (React.createElement(Choice, Object.assign({ id: id, disabled: disabled }, otherProps),
        React.createElement(Input, { ref: checkboxRef, id: id, type: "checkbox", checked: checked, value: value, name: name, disabled: disabled, "aria-label": ariaLabel, className: className, onChange: handleChange })));
};
//# sourceMappingURL=Checkbox.js.map